var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.796,
    height: 28.5,
    viewBox: "0 0 22.796 28.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Secure Checkout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.33 -26.25)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1536",
    d: "M41.8,26.25a.75.75,0,0,1,.168.019l10.572,2.437a.75.75,0,0,1,.582.731V41.125A12.9,12.9,0,0,1,45.344,53l-3.274,1.672a.75.75,0,0,1-.682,0l-3.276-1.673A13.034,13.034,0,0,1,30.33,41.147V29.455a.75.75,0,0,1,.583-.731l10.724-2.455A.75.75,0,0,1,41.8,26.25Zm9.822,3.784L41.8,27.77,31.83,30.052V41.143a11.531,11.531,0,0,0,6.9,10.487l.04.019,2.955,1.509,2.955-1.509.044-.021a11.4,11.4,0,0,0,6.9-10.5Z",
    fill: "#767983"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 497",
    d: "M0,6.191a.75.75,0,0,1-.645-.366A.75.75,0,0,1-.384,4.8L8.733-.644a.75.75,0,0,1,1.028.26A.75.75,0,0,1,9.5.644L.384,6.085A.747.747,0,0,1,0,6.191Z",
    transform: "translate(43.107 32.979)",
    fill: "#767983"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 498",
    d: "M0,6.191a.75.75,0,0,1-.645-.366A.75.75,0,0,1-.384,4.8L8.733-.644a.75.75,0,0,1,1.028.26A.75.75,0,0,1,9.5.644L.384,6.085A.747.747,0,0,1,0,6.191Z",
    transform: "translate(43.107 37.806)",
    fill: "#767983"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureIcon);
export default __webpack_public_path__ + "static/media/secure-icon.a0bbbbd1.svg";
export { ForwardRef as ReactComponent };